import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./LoginSignatureForm.module.css";

export const LoginSignatureForm = ({ handlePKISubmit}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.formWrapper}>
      <form action={'/challenger'} className={styles.form}>
        <button className={styles.submit} onClick={handlePKISubmit}>
        {t("login.login")}
        </button>
      </form>
    </div>
  );
};
